import type { TPaddingObjectFilterCriteria } from '@timeedit/types';
import { Icon, type TEIOption, TEInput } from '@timeedit/ui-components';

type Props = {
  index: number;
  impactedObject: TPaddingObjectFilterCriteria & { impacted?: boolean };
  typeOptions: TEIOption[];
  fieldOptions: TEIOption[];
  fieldValueOptions: TEIOption[];
  onCriteriaUpdated: (index: number, criteria: any) => void;
  showImpact: boolean;
  onDelete?: () => void;
};

const FieldValueSelect = ({
  index,
  impactedObject,
  typeOptions,
  fieldOptions,
  fieldValueOptions,
  onCriteriaUpdated,
  showImpact,
  onDelete,
}: Props) => {
  return (
    <div className="field-value">
      <div className="wrapper">
        <TEInput.Select
          data-testid={`object-type-${index}`}
          label="Field value"
          value={
            (impactedObject.typeId && impactedObject.typeId?.toString()) ||
            undefined
          }
          options={typeOptions}
          onChange={(val) =>
            onCriteriaUpdated(index, {
              typeId: val && Number(val),
              fieldCriteria: {},
            })
          }
          placeholder="Select"
        />
        <TEInput.Select
          data-testid={`field-key-${index}`}
          options={fieldOptions}
          value={
            (impactedObject.fieldCriteria?.fieldId &&
              impactedObject.fieldCriteria?.fieldId?.toString()) ||
            undefined
          }
          onChange={(val) =>
            onCriteriaUpdated(index, {
              fieldCriteria: {
                fieldId: val && Number(val),
              },
            })
          }
          placeholder="Select"
        />
        <TEInput.Select
          data-testid={`field-value-${index}`}
          value={impactedObject.fieldCriteria?.fieldValues}
          options={fieldValueOptions}
          onChange={(val) =>
            onCriteriaUpdated(index, {
              fieldCriteria: {
                ...impactedObject.fieldCriteria,
                fieldValues: val,
              },
            })
          }
          mode="multiple"
          placeholder="Select"
        />
      </div>
      <div className="wrapper">
        {showImpact && (
          <TEInput.Switch
            checked={impactedObject.impacted}
            onChange={(val) => {
              onCriteriaUpdated(index, { impacted: val });
            }}
            label="Impacted"
          />
        )}
        {onDelete && (
          <Icon id="DeleteOutlined" alt="Delete" onClick={onDelete} />
        )}
      </div>
    </div>
  );
};

export default FieldValueSelect;
